(() => {
 'use strict';
 const strings=JSON.parse(document.getElementById('fm-mobile-strings')?.textContent||'{}');
 const mobile=matchMedia('(max-width:749px)');
 const menu=document.getElementById('fm-menu');
 if(menu){
  const chrome=document.createElement('div');chrome.className='fm-menu-chrome';
  const notice=document.querySelector('.fm-notice').cloneNode(true);
  const header=document.querySelector('[data-header]').cloneNode(true);
  header.removeAttribute('data-header');header.classList.add('is-scrolled');
  header.querySelector('.fm-nav')?.remove();
  const close=header.querySelector('.fm-menu-trigger');
  close.removeAttribute('data-open');close.setAttribute('data-close','');close.setAttribute('aria-label',strings.close);
  close.innerHTML=menu.querySelector('[data-close]').innerHTML;
  chrome.append(notice,header);menu.prepend(chrome);
  const panels=[...menu.querySelectorAll('[data-mobile-panel]')];
  const heading=menu.querySelector('.fm-dialog-head h2');
  const back=document.createElement('button');back.type='button';back.className='fm-mobile-back';
  const arrow=document.createElement('span');arrow.textContent='‹';arrow.setAttribute('aria-hidden','true');
  const label=document.createElement('span');back.append(arrow,label);heading.replaceWith(back);
  let stack=['root'];
  const render=(focus)=>{
   const name=stack.at(-1),panel=panels.find(p=>p.dataset.mobilePanel===name);
   panels.forEach(p=>p.hidden=p!==panel);
   menu.dataset.mobileLevel=name;
   back.disabled=name==='root';label.textContent=name==='root'?strings.menu:panel.dataset.mobileLabel;
   back.setAttribute('aria-label',name==='root'?strings.menu:strings.back+' '+panel.dataset.mobileLabel);
   menu.querySelectorAll('[data-mobile-forward]').forEach(b=>b.setAttribute('aria-expanded',String(stack.includes(b.dataset.mobileForward))));
   menu.scrollTop=0;if(focus)back.focus({preventScroll:true});
  };
  menu.querySelectorAll('[data-mobile-forward]').forEach(b=>b.addEventListener('click',()=>{stack.push(b.dataset.mobileForward);render(true);}));
  back.addEventListener('click',()=>{const previous=stack.pop();render(false);menu.querySelector('[data-mobile-forward="'+previous+'"]')?.focus({preventScroll:true});});
  menu.addEventListener('keydown',e=>{if(e.key==='Escape'&&stack.length>1){e.preventDefault();e.stopPropagation();back.click();}});
  menu.addEventListener('close',()=>{stack=['root'];render(false);});render(false);
 }
 document.querySelectorAll('[data-product-root]').forEach(product=>{
  const stage=product.querySelector('.fm-product-stage');
  const title=product.querySelector('.fm-purchase-product');
  const rail=product.querySelector('.fm-product-options-rail');
  const dialog=product.querySelector('.fm-option-popover');
  const sticky=product.querySelector('[data-sticky-purchase]');
  if(!stage||!title||!sticky)return;
  const panel=document.createElement('div');panel.className='fm-mobile-configuration';stage.after(panel);
  const nodes=[title,rail,dialog].filter(Boolean).map(node=>{const marker=document.createTextNode('');node.before(marker);return{node,marker};});
  const labels=[...product.querySelectorAll('[data-option-focus] .fm-option-pill-copy small')].map(node=>({node,text:node.textContent}));
  const image=product.querySelector('.fm-gallery-slide img');
  if(image){
   product.querySelectorAll('[data-custom-group="size"] .fm-config-tile>span').forEach(tile=>{const photo=document.createElement('img');photo.src=image.currentSrc||image.src;photo.alt='';photo.loading='lazy';photo.width=150;photo.height=95;tile.prepend(photo);});
   const icon=product.querySelector('[data-custom-icon="size"]');if(icon){const photo=document.createElement('img');photo.src=image.currentSrc||image.src;photo.alt='';icon.replaceChildren(photo);}
  }
  const confirm=document.createElement('button');confirm.type='button';confirm.className='fm-button fm-mobile-confirm';confirm.textContent=strings.confirm;confirm.hidden=true;sticky.append(confirm);
  let opener;
  const anchor=()=>{const top=panel.getBoundingClientRect().top+scrollY-(document.querySelector('[data-header]').getBoundingClientRect().bottom+10);if(panel.getBoundingClientRect().top<document.querySelector('[data-header]').getBoundingClientRect().bottom||panel.getBoundingClientRect().top>innerHeight-230)window.scrollTo({top:Math.max(0,top),behavior:'instant'});};
  const sync=()=>{
   const active=mobile.matches&&dialog?.open;
   panel.classList.toggle('is-configuring',!!active);sticky.classList.toggle('is-configuring',!!active);confirm.hidden=!active;
   if(active){
    const family=dialog.querySelector('[data-fabric-family]');
    if(dialog.dataset.activeGroup==='colour'&&family?.value==='all'){family.value='Chenille';family.dispatchEvent(new Event('change'));}
    const heading=dialog.querySelector('h2');if(!heading.textContent.startsWith(strings.choose+' '))heading.textContent=strings.choose+' '+heading.textContent;
    anchor();
   }
  };
  const layout=()=>{
   if(dialog?.open)dialog.close();
   if(mobile.matches){
    nodes.forEach(({node})=>panel.append(node));dialog?.classList.add('fm-mobile-option-panel');
    dialog?.querySelectorAll('img').forEach(img=>img.loading='eager');
    labels.forEach(({node})=>{const index=node.closest('[data-option-focus]').dataset.optionFocus;node.textContent=product.querySelector('[data-option-index="'+index+'"]').dataset.optionName;});
   }else{
    nodes.forEach(({node,marker})=>marker.after(node));dialog?.classList.remove('fm-mobile-option-panel');labels.forEach(({node,text})=>node.textContent=text);
   }
   sync();
  };
  rail?.addEventListener('click',e=>{opener=e.target.closest('button');});
  confirm.addEventListener('click',()=>dialog?.close());
  if(dialog){
   new MutationObserver(sync).observe(dialog,{attributes:true,attributeFilter:['open']});
   dialog.addEventListener('close',()=>{sync();if(mobile.matches)opener?.focus({preventScroll:true});});
   document.addEventListener('keydown',e=>{if(e.key==='Escape'&&mobile.matches&&dialog.open){e.preventDefault();dialog.close();}});
  }
  mobile.addEventListener('change',layout);layout();
 });
})();
